export const isBrowser = () => typeof window !== "undefined"

export const nodeType = () => process.env.NODE_ENV

export const isProductionNode = () => nodeType() === "production"
